import { render, staticRenderFns } from "./RedirectDispatchModal.vue?vue&type=template&id=a16cc232&scoped=true&"
import script from "./RedirectDispatchModal.vue?vue&type=script&lang=js&"
export * from "./RedirectDispatchModal.vue?vue&type=script&lang=js&"
import style0 from "./RedirectDispatchModal.vue?vue&type=style&index=0&id=a16cc232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16cc232",
  null
  
)

export default component.exports